import styles from '@/components/models/travel/PricingBlock/PricingBlock.module.scss'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { TitleH2 } from '@/components/cms/Title'
import { useTranslation } from 'next-i18next'
import travelObject from '@/entities/travel/interface'
import PricingBlockInfo from '@/components/models/travel/PricingBlock/PricingBlockInfo'
import PricingBlockServices from '@/components/models/travel/PricingBlock/PricingBlockServices'

interface Props {
  travel: travelObject
}

const PricingBlock = ({ travel }: Props) => {
  const { includedServices, excludedServices, pricingTable, priceCalculationInfo } = travel
  const { t } = useTranslation('common')

  return (
    <Container fluid className={styles.root} data-tr-view="travel_page:pricing_info:view">
      <Row>
        <Col>
          <Container className={styles.container}>
            <span id="pricing" className="anchor" />
            <Row>
              <TitleH2 title={t('travel.pricesAndServices')} className={styles.title} />
              <PricingBlockInfo pricingTable={pricingTable} priceCalculationInfo={priceCalculationInfo} />
              <PricingBlockServices includedServices={includedServices} excludedServices={excludedServices} travel={travel} />
            </Row>
          </Container>
        </Col>
      </Row>
    </Container>
  )
}

export default PricingBlock
